import { appConfigTypes as actionTypes } from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const collectionState = {
  ...commonState.default(),
};

export const appConfig = (state = collectionState, action) =>
  commonReducer(actionTypes, state, action);
